export default {
      id: "type-group-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#type-group",
      toString: function () {
        return this.url;
      }
    }